import moment from 'moment'
import {mapState, mapGetters} from 'vuex'

function buildFallbackRange(currentAccountDate) {
	return {
		startDate: currentAccountDate || null,
		endDate: currentAccountDate || null
	};
}

export default {
	data() {
		return {
			accountBookPeriodRangeReady: false
		};
	},
	computed: {
		...mapState(['currentAccountSets']),
		...mapGetters(['accountBookPeriodRange'])
	},
	watch: {
		'currentAccountSets.id': {
			immediate: true,
			handler() {
				this.restoreAccountBookPeriodRange();
			}
		},
		periodRange: {
			deep: true,
			handler(val) {
				if (!this.accountBookPeriodRangeReady) {
					return;
				}
				if (!this.currentAccountSets || !this.currentAccountSets.id) {
					return;
				}
				this.$store.commit('updateAccountBookPeriodRange', {
					accountSetsId: this.currentAccountSets.id,
					range: this.normalizeAccountBookPeriodRange(val)
				});
			}
		}
	},
	methods: {
		normalizeAccountBookPeriodRange(range) {
			const fallback = buildFallbackRange(this.currentAccountSets && this.currentAccountSets.currentAccountDate);
			const startDate = range && range.startDate ? range.startDate : fallback.startDate;
			const endDate = range && range.endDate ? range.endDate : fallback.endDate;
			if (!startDate || !endDate) {
				return fallback;
			}
			if (moment(startDate).isAfter(endDate)) {
				return {
					startDate: endDate,
					endDate: startDate
				};
			}
			return {
				startDate,
				endDate
			};
		},
		isSameAccountBookPeriodRange(a, b) {
			return !!a && !!b && a.startDate === b.startDate && a.endDate === b.endDate;
		},
		restoreAccountBookPeriodRange() {
			if (!this.periodRange) {
				return;
			}
			const accountSetsId = this.currentAccountSets && this.currentAccountSets.id;
			const cachedRange = accountSetsId ? this.accountBookPeriodRange(accountSetsId) : null;
			const normalizedRange = this.normalizeAccountBookPeriodRange(cachedRange || this.periodRange);
			this.accountBookPeriodRangeReady = false;
			if (!this.isSameAccountBookPeriodRange(this.periodRange, normalizedRange)) {
				this.periodRange = normalizedRange;
			}
			this.$nextTick(() => {
				this.accountBookPeriodRangeReady = true;
				if (typeof this.onAccountBookPeriodRangeReady === 'function') {
					this.onAccountBookPeriodRangeReady();
				}
			});
		}
	}
}
